<ion-header>
    <ion-toolbar>

        <!-- <ion-title mode="ios" role="heading">{{ 'TERMS_HEADER' | translate}}</ion-title> -->

        <ion-buttons slot="end">
            <ion-button
                class="icon-button-accessible-background-contrast"
                [attr.aria-label]="'ARIA_LABEL_CLOSE' | translate"
                (click)="dismiss()">
                <ion-icon slot="icon-only" name="close"></ion-icon>
            </ion-button>
        </ion-buttons>

    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-slides pager="false" [options]="slideOpts" #slides>
        <ion-slide [attr.aria-hidden]="slideIndex !== 0">
          <img src="assets/imgs/stop1.png" class="slide-image" />
        </ion-slide>
        <ion-slide [attr.aria-hidden]="slideIndex !== 1">
          <img src="assets/imgs/stop2.png" class="slide-image" />
        </ion-slide>
        <ion-slide [attr.aria-hidden]="slideIndex !== 2">
          <img src="assets/imgs/stop3.png" class="slide-image" />
        </ion-slide>
      </ion-slides>

    <ion-row class="hide-for-small-screen">
        <ion-col>
            <ion-button
                expand="block"
                class="emphasized-button"
                [disabled]="slideIndex === 0"
                (click)="slidePrev()"
                [innerHTML]="'BUTTON_PREVIOUS' | translate">
            </ion-button>
        </ion-col>
        <ion-col>
            <ion-button
                expand="block"
                class="emphasized-button"
                (click)="slideNext()">
                {{ (slideIndex !== 2 ? 'BUTTON_NEXT' : 'BUTTON_DONE') | translate }}
            </ion-button>
        </ion-col>
    </ion-row>
</ion-content>

<ion-footer class="hide-for-large-screen">
    <ion-row>
        <ion-col>
            <ion-button
                expand="full"
                color="light"
                (click)="slidePrev()"
                [disabled]="slideIndex === 0"
                [innerHTML]="'BUTTON_PREVIOUS' | translate"></ion-button>
        </ion-col>
        <ion-col>
            <ion-button
                expand="full"
                color="light"
                (click)="slideNext()">
                {{ (slideIndex !== 2 ? 'BUTTON_NEXT' : 'BUTTON_DONE') | translate }}
            </ion-button>
        </ion-col>
    </ion-row>
</ion-footer>
